<template>
  <div v-if="product && productPrice">
    <div class="flex gap-4 between">
      <template v-if="product.eyebrow">
        <vf-toggletip v-if="product.eyebrow.details">
          <template #trigger>
            <span class="flex items-center gap-1">
              <p v-bind="eyebrowStyle" class="line-clamp-1 eyebrow">
                {{ product.eyebrow.label }}
              </p>
              <vf-icon name="info" />
            </span>
          </template>
          {{ product.eyebrow.details }}
        </vf-toggletip>
        <p
          v-else-if="product.eyebrow.label"
          v-bind="eyebrowStyle"
          class="line-clamp-1 eyebrow"
        >
          {{ product.eyebrow.label }}
        </p>
      </template>
      <pdp-section-breadcrumbs class="ml-a" />
    </div>
    <h1 class="body-2 mt-1" data-test-id="product-name">
      {{ product.name }}
    </h1>
    <transition name="slide">
      <p
        v-if="$feature.showShortDescriptionOnPDP && product.shortDescription"
        class="body-4 c-grey-30"
        :class="{ '<lg:hidden': !isDrawerExpanded }"
        style="margin-top: 0.125rem"
      >
        {{ product.shortDescription }}
      </p>
    </transition>
    <product-pricing
      class="body-3 mt-1"
      :currency="product.currency"
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-omnibus-details="isDrawerExpanded"
      :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
    />
    <div ref="promotionRef" class="body-4 truncate space-y-2" :class="{ 'mt-2': !!promotionDivHeight, '<lg:hidden': !isDrawerExpanded }">
      <p v-if="product.promoExclusionsMessage">
        {{ product.promoExclusionsMessage }}
      </p>
      <div id="below-price-info" />
      <p v-if="isComingSoon" class="py-1">
        <span class="rounded-sm bg-grey-90 px-2 py-1">{{ comingSoonText }}</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatDate } from '@vueuse/core'

defineProps<{
  isDrawerExpanded?: boolean
}>()

const { $feature, $t } = useNuxtApp()
const { eyebrowStyle, isComingSoon, product, productPrice } = usePdp()
const promotionRef = ref()

const { height: promotionDivHeight } = useElementBounding(promotionRef)

const comingSoonText = computed(() => {
  if (product.value?.targetPublishDate) {
    const formattedDate = formatDate(
      new Date(product.value.targetPublishDate.replace(/-/g, '\/')),
      $feature.configProductComingSoonDateFormat
    )
    return `${$t.comingSoon} – ${formattedDate}`
  }

  return $t.comingSoon
})
</script>
